/** Full-page loading and failure states. An empty screen always offers a way on. */
import { el, type Child } from './dom';

export function loadingState(text = 'Loading'): HTMLElement {
  return el(
    'div',
    { class: 'page-state' },
    el(
      'div',
      { class: 'page-state__inner' },
      el('span', { class: 'spinner' }),
      el('div', { class: 'muted small', text }),
    ),
  );
}

export interface ErrorStateOptions {
  title: string;
  description: string;
  actions?: Child[];
}

export function errorState(options: ErrorStateOptions): HTMLElement {
  return el(
    'div',
    { class: 'page-state' },
    el(
      'div',
      { class: 'page-state__inner' },
      el('h1', { text: options.title }),
      el('p', { class: 'muted', text: options.description }),
      options.actions?.length ? el('div', { class: 'row' }, ...options.actions) : null,
    ),
  );
}
